'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var parser_1 = require('../parser');

function combine(psbts) {
  var self = psbts[0];
  var selfKeyVals = parser_1.psbtToKeyVals(self);
  var others = psbts.slice(1);
  if (others.length === 0) throw new Error('Combine: Nothing to combine');
  var selfTx = getTx(self);

  if (selfTx === undefined) {
    throw new Error('Combine: Self missing transaction');
  }

  var selfGlobalSet = getKeySet(selfKeyVals.globalKeyVals);
  var selfInputSets = selfKeyVals.inputKeyVals.map(getKeySet);
  var selfOutputSets = selfKeyVals.outputKeyVals.map(getKeySet);

  var _iterator = _createForOfIteratorHelper(others),
      _step;

  try {
    var _loop = function _loop() {
      var other = _step.value;
      var otherTx = getTx(other);

      if (otherTx === undefined || !otherTx.toBuffer().equals(selfTx.toBuffer())) {
        throw new Error('Combine: One of the Psbts does not have the same transaction.');
      }

      var otherKeyVals = parser_1.psbtToKeyVals(other);
      var otherGlobalSet = getKeySet(otherKeyVals.globalKeyVals);
      otherGlobalSet.forEach(keyPusher(selfGlobalSet, selfKeyVals.globalKeyVals, otherKeyVals.globalKeyVals));
      var otherInputSets = otherKeyVals.inputKeyVals.map(getKeySet);
      otherInputSets.forEach(function (inputSet, idx) {
        return inputSet.forEach(keyPusher(selfInputSets[idx], selfKeyVals.inputKeyVals[idx], otherKeyVals.inputKeyVals[idx]));
      });
      var otherOutputSets = otherKeyVals.outputKeyVals.map(getKeySet);
      otherOutputSets.forEach(function (outputSet, idx) {
        return outputSet.forEach(keyPusher(selfOutputSets[idx], selfKeyVals.outputKeyVals[idx], otherKeyVals.outputKeyVals[idx]));
      });
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return parser_1.psbtFromKeyVals(selfTx, {
    globalMapKeyVals: selfKeyVals.globalKeyVals,
    inputKeyVals: selfKeyVals.inputKeyVals,
    outputKeyVals: selfKeyVals.outputKeyVals
  });
}

exports.combine = combine;

function keyPusher(selfSet, selfKeyVals, otherKeyVals) {
  return function (key) {
    if (selfSet.has(key)) return;
    var newKv = otherKeyVals.filter(function (kv) {
      return kv.key.toString('hex') === key;
    })[0];
    selfKeyVals.push(newKv);
    selfSet.add(key);
  };
}

function getTx(psbt) {
  return psbt.globalMap.unsignedTx;
}

function getKeySet(keyVals) {
  var set = new Set();
  keyVals.forEach(function (keyVal) {
    var hex = keyVal.key.toString('hex');
    if (set.has(hex)) throw new Error('Combine: KeyValue Map keys should be unique');
    set.add(hex);
  });
  return set;
}